import type { SolutionSector } from "../sectors";
import { COST_QUESTION, EFFORT_QUESTION, HOSTING_QUESTION, LOGO } from "./shared";

export const PE_VC: SolutionSector = {
  slug: "pe-vc",
  name: "Private equity & venture capital",
  demoOrg: "Demo (PE + VC)",
  story: "pe_vc",
  metadata: {
    title: "AI for portfolio reporting reviews | Your Twin",
    description:
      "See which reporting packs are incomplete before the portfolio review. Your Twin connects Google Sheets, SharePoint and Outlook, so you can see missing items, periods and owners.",
  },
  hero: {
    label: "Private equity & venture capital",
    title: ["Find the gaps", "before the", "portfolio review."],
    lead: [
      "Which packs are incomplete, and what’s missing? Your Twin connects trackers in ",
      LOGO.sheets,
      ", packs in ",
      LOGO.sharepoint,
      " and requests in ",
      LOGO.outlook,
      ", with each gap beside its period and owner.",
    ],
    cta: "Bring a reporting pack",
    buyer: "For operating partners, portfolio operations directors and portfolio finance directors",
    instrumentLabel: "The portfolio Twin · Company, period, pack and owner",
  },
  replay: {
    title: "Which packs are incomplete?\nAnd what’s missing?",
    lead: "Ask across the reporting register, the packs and the requests. See each gap beside its period and follow-up owner.",
  },
  outcomes: {
    title: "Every gap in view\nbefore the review.",
    lead: "The operating team sees what each company has sent, which period it covers and who is following up.",
    items: [
      { title: "Find the reporting gap.", body: "Compare the expected pack with the records received.", show: "status" },
      { title: "Keep periods visible.", body: "See which month each figure or document covers.", show: "sources" },
      { title: "Prepare the right questions.", body: "Bring unresolved points and their owners into the review.", show: "owners" },
    ],
  },
  start: { firstStep: "Choose the reporting pack your team rebuilds each month." },
  questions: [
    { q: "Will it value businesses or recommend investments?", a: "No. This workflow prepares evidence for your team. Valuation and investment decisions stay with you." },
    {
      q: "Can it compare performance across companies?",
      a: "Only where definitions, periods, currencies and sources have been agreed. Where definitions differ, they stay visible rather than becoming a ranking.",
    },
    {
      q: "Does this combine all our portfolio companies’ systems?",
      a: "This example uses records held by the investment firm. Connecting a portfolio company’s own systems needs that company’s agreement and a setup we agree with you.",
    },
    HOSTING_QUESTION,
    EFFORT_QUESTION,
    COST_QUESTION,
  ],
  closing: "Start with the reporting pack\nyour team rebuilds each month.",
};
